// extracted by mini-css-extract-plugin
export default {"cls1":"U3di0kARY03xGt3jlAtQ","cls2":"Z5qEZ5Y7qcegRtReSPCZ U3di0kARY03xGt3jlAtQ"};